import clsx from 'clsx'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import useStyles from './_styles'
import items from './_headerNavigation.def'

const HeaderNavigation = () => {
    const classes = useStyles()
    const location = useLocation()

    return (
        <div className={classes.HeaderNavigation}>
            <div className={classes.HeaderNavigationInner}>
                {items.map((item) => (
                    <Link
                        className={clsx(
                            classes.HeaderNavigationItem,
                            location.pathname === item.to && classes.HeaderNavigationItemActive
                        )}
                        to={item.to}
                        key={item.label}
                        data-cy={item.dataCy}
                    >
                        {item.label}
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default HeaderNavigation
